import { formatTime } from '@lyearn/core/utils/time';
import { MediaKindEnum } from '@/types/schema';

import { MediaGridProps, MediaSize } from '../types';
import GridImage from './Image';
import { getHeight } from './styles';
import GridVideo from './Video';

export const shouldPlayInline = (media: MediaGridProps['media'], size: MediaSize) => {
  return media.kind === MediaKindEnum.Video && [MediaSize.AUTO, MediaSize.LARGE].includes(size);
};

export const getSizeClasses = (size: MediaSize, totalMedias: number) => {
  switch (size) {
    case MediaSize.SMALL:
      return { width: 96, height: 96, classes: 'w-96 h-96' };
    case MediaSize.LARGE:
      return { width: 256, height: 256, classes: 'w-256 h-256' };
    case MediaSize.AUTO:
      return { classes: `${getHeight(61.6)} w-full` };
    case MediaSize.ADJUST: {
      const height = totalMedias === 1 ? 45.6 : totalMedias === 2 ? 22.2 : 14.4;
      return { classes: `w-full ${getHeight(height)}` };
    }
    default:
      return {};
  }
};

export const getDurationText = (duration: number) => {
  const { hours, minutes, seconds } = formatTime(duration!);

  if (!hours || hours === '00') {
    return `${minutes}:${seconds}`;
  }

  return `${hours}:${minutes}:${seconds}`;
};

export const GRID_RENDER_COMPONENT = {
  [MediaKindEnum.Image]: GridImage,
  [MediaKindEnum.Video]: GridVideo,
} as Record<MediaKindEnum, typeof GridImage | undefined>;
